import { render, staticRenderFns } from "./NewsTableAction.vue?vue&type=template&id=2fce5af4"
import script from "./NewsTableAction.vue?vue&type=script&lang=js"
export * from "./NewsTableAction.vue?vue&type=script&lang=js"
import style0 from "./NewsTableAction.vue?vue&type=style&index=0&id=2fce5af4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports